import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/LongTermLease/LongTermLease.requests'
import {
    LongTermLeaseType,
} from '../longTermLease.types'

const useUpdateLongTermLease = (id: number, onSuccess: ({
    id: number,
}) => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessLongTermLeaseUpdate,
        onError,
    } = useHandleStatusRequest({
        title: 'Long-Term Lease was updated',
        id: 'LongTermLease',
        onSuccess,
    })

    return useMutation({
        mutationFn: (longTermLease: LongTermLeaseType) => {
            return simpleApi({
                ...requests.update({
                    longTermLeaseId: id,
                    data: longTermLease,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessLongTermLeaseUpdate,
    })
}

export default useUpdateLongTermLease
